module.exports = __webpack_public_path__ + "static/media/Dosis-Medium.9bc7d1d1.ttf";